import { Koi } from '@ksyos/koi';
import type { IRequestBankAccountDetailsChange } from '../interfaces/requestBankAccountDetailsChange';
import type { ISchemaContainer } from './schemaContainer';

const requestBankAccountDetailsChange = Koi.object().keys({
    bankAccountNumber: Koi.string(),
    subscriber: Koi.string().trim().max(255),
});

export const requestBankAccountDetailsChangeSchema: ISchemaContainer<IRequestBankAccountDetailsChange> = {
    schema: requestBankAccountDetailsChange.options({ convert: false, presence: 'required' }),
};
